import useThreeJs from './useThreeJs';

export default useThreeJs;
